import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCheckboxCheckedIcon, DownloadIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    downloadButtonClick: () => void;
    propertyPlan: string;
}

export const GalleryHolderPropertyPlanAuthConfirmationModal = (props: IProps) => {
    const {downloadButtonClick, propertyPlan} = props;

    return (
        <div className={card}>
            <BrandCheckboxCheckedIcon size="16" wrapperSize="16" wrapperColor="var(--colors-primary)" />

            <Text align="center" variant="headline_2" strong>
                Twoje konto <br /> zostało utworzone.
            </Text>

            <div className={buttonStyle}>
                <Button onClick={downloadButtonClick} variant="outlined_secondary_light" href={propertyPlan} target="_blank" iconLeft={DownloadIcon}>
                    Pobierz rzut
                </Button>
            </div>
        </div>
    );
};

const card = css({
    width: "100%",
    backgroundColor: "var(--colors-white)",
    gap: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    md: {
        borderRadius: 3,
        pb: 1,
        pl: 1,
        pr: 1
    }
});

const buttonStyle = css({
    display: "flex",
    justifyContent: "center",
    width: "100%"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCheckboxCheckedIcon, DownloadIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    downloadButtonClick: () => void;
    propertyPlan: string;
}

export const GalleryHolderPropertyPlanAuthConfirmationModal = (props: IProps) => {
    const {downloadButtonClick, propertyPlan} = props;

    return (
        <div className={card}>
            <BrandCheckboxCheckedIcon size="16" wrapperSize="16" wrapperColor="var(--colors-primary)" />

            <Text align="center" variant="headline_2" strong>
                Twoje konto <br /> zostało utworzone.
            </Text>

            <div className={buttonStyle}>
                <Button onClick={downloadButtonClick} variant="outlined_secondary_light" href={propertyPlan} target="_blank" iconLeft={DownloadIcon}>
                    Pobierz rzut
                </Button>
            </div>
        </div>
    );
};

const card = css({
    width: "100%",
    backgroundColor: "var(--colors-white)",
    gap: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    md: {
        borderRadius: 3,
        pb: 1,
        pl: 1,
        pr: 1
    }
});

const buttonStyle = css({
    display: "flex",
    justifyContent: "center",
    width: "100%"
});
